import type React from 'react';

import type { PetitionEditPageState } from 'src/app/pages/petitionEditV2/pageContext';

import { DecisionMakerCard } from './components/DecisionMakerCard';
import { EditDecisionMakerForm } from './components/EditDecisionMakerForm';
import { useSelectedDecisionMaker } from './hooks/useSelectedDecisionMaker';

type DecisionMakerType = PetitionEditPageState['formState']['decisionMakers']['value'][number];

type Props = {
	decisionMaker: DecisionMakerType;
	onRemoveDecisionMaker: () => void;
};

export const SelectedDecisionMaker: React.FC<Props> = ({ decisionMaker, onRemoveDecisionMaker }) => {
	const { data, actions } = useSelectedDecisionMaker(decisionMaker);

	return data.viewMode === 'READONLY' ? (
		<DecisionMakerCard
			decisionMaker={decisionMaker}
			onRemoveDecisionMaker={onRemoveDecisionMaker}
			setEditing={() => actions.setViewMode('EDITING')}
		/>
	) : (
		<EditDecisionMakerForm
			decisionMaker={decisionMaker}
			setReadonly={() => actions.setViewMode('READONLY')}
			onRemoveDecisionMaker={onRemoveDecisionMaker}
			mode={data.viewMode}
		/>
	);
};
